import { render, staticRenderFns } from "./order-satisfaction-rate-add.vue?vue&type=template&id=24b0b1b5&scoped=true"
import script from "./order-satisfaction-rate-add.vue?vue&type=script&lang=js"
export * from "./order-satisfaction-rate-add.vue?vue&type=script&lang=js"
import style0 from "./order-satisfaction-rate-add.vue?vue&type=style&index=0&id=24b0b1b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0b1b5",
  null
  
)

export default component.exports